import { render, staticRenderFns } from "./panel.vue?vue&type=template&id=3b2c023a&scoped=true"
import script from "./panel.vue?vue&type=script&lang=ts"
export * from "./panel.vue?vue&type=script&lang=ts"
import style0 from "./panel.vue?vue&type=style&index=0&id=3b2c023a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b2c023a",
  null
  
)

export default component.exports